/* Collection team-logo row (snippets/collection-audience-chips.liquid): desktop scroll arrows and the team-name tooltip
   on hover; phones just swipe the row. Every listener is delegated on document, because the theme's AJAX filtering
   replaces the whole button area (and with it this row) on every filter change. */
(function () {
  var tip = null;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function teamLink(target) { return target && target.closest ? target.closest('.bc-chips__team') : null; }

  function hideTip() { if (tip) tip.classList.remove('is-on'); }

  function showTip(link) {
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'bc-teamtip';
      tip.setAttribute('aria-hidden', 'true');
      document.body.appendChild(tip);
    }
    var r = link.getBoundingClientRect();
    tip.textContent = link.getAttribute('aria-label') || '';
    tip.style.left = Math.round(r.left + r.width / 2) + 'px';
    tip.style.top = Math.round(r.bottom + 8) + 'px';
    tip.classList.add('is-on');
  }

  function updateArrows(bar) {
    var list = bar && bar.querySelector('.bc-chips__teams');
    if (!list) return;
    var max = list.scrollWidth - list.clientWidth;
    var prev = bar.querySelector('[data-team-scroll="-1"]');
    var next = bar.querySelector('[data-team-scroll="1"]');
    if (prev) prev.hidden = list.scrollLeft <= 2;
    if (next) next.hidden = max <= 2 || list.scrollLeft >= max - 2;
  }

  function init() {
    hideTip();
    Array.prototype.forEach.call(document.querySelectorAll('.bc-teambar'), function (bar) {
      var list = bar.querySelector('.bc-chips__teams');
      var active = list && list.querySelector('.tag--active .bc-chips__team');
      if (active) {
        var item = active.parentNode;
        list.scrollLeft = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
      }
      updateArrows(bar);
    });
  }

  if (canHover) {
    document.addEventListener('mouseover', function (e) { var link = teamLink(e.target); if (link) showTip(link); });
    document.addEventListener('mouseout', function (e) {
      var link = teamLink(e.target);
      if (link && !link.contains(e.relatedTarget)) hideTip();
    });
    document.addEventListener('focusin', function (e) { var link = teamLink(e.target); if (link) showTip(link); });
    document.addEventListener('focusout', function (e) { if (teamLink(e.target)) hideTip(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-team-scroll]');
    if (btn) {
      var bar = btn.closest('.bc-teambar');
      var list = bar && bar.querySelector('.bc-chips__teams');
      if (!list) return;
      list.scrollBy({ left: Number(btn.getAttribute('data-team-scroll')) * Math.max(list.clientWidth * 0.8, 120), behavior: 'smooth' });
      return;
    }
    if (teamLink(e.target)) hideTip();
  });

  // scroll does not bubble: listen in the capture phase for the row's own scrolling
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('bc-chips__teams')) { hideTip(); updateArrows(el.closest('.bc-teambar')); }
  }, true);
  window.addEventListener('scroll', hideTip, { passive: true });
  window.addEventListener('resize', init);
  document.addEventListener('collection:reloaded', init);   // theme.js, after every AJAX filter render
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
